'use strict';

/**
 * Converts object to query string
 *
 * @param   {Object} data   a map to convert
 * @returns {String}        query string
 */
function mapToQuery(data) {
  const res = [];

  for (const key in data) {
    if (data.hasOwnProperty(key)) { // eslint-disable-line
      res.push(`${key}=${encodeURIComponent(data[key])}`);
    }
  }

  return res.join('&');
}

/**
 * Generates a valid GUID
 *
 * @returns {String}  GUID
 */
function generateGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random()*16 | 0, v = c === 'x' ? r : (r&0x3 | 0x8); // eslint-disable-line
    return v.toString(16);
  });
}

export default {
  mapToQuery,
  generateGuid
};



// WEBPACK FOOTER //
// ./tools/tools.js